export const assign24SolidIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 26"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M3 5.5 6.75 10 3 14.5m13.5-6.75a3 3 0 1 0 0-6 3 3 0 0 0 0 6m5.25 6.75a5.25 5.25 0 1 0-10.5 0v2.25h2.25l.75 7.5h4.5l.75-7.5h2.25z"/></svg>`,
    name: 'assign-24-solid'
};